"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configRefreshTokenRoutes = void 0;
const miragejs_1 = require("miragejs");
const configurations_1 = require("../../../data-manager/configurations");
function configRefreshTokenRoutes(server) {
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.AUTHORIZATION_REFRESH, (schema, request) => {
        return new miragejs_1.Response(200, {}, {});
    });
    return server;
}
exports.configRefreshTokenRoutes = configRefreshTokenRoutes;
